import {ready} from '../main/utils';

let passiveIfSupported = false;

window.addEventListener(
  'test',
  null,
  Object.defineProperty({}, 'passive', {
    get: function() {
      passiveIfSupported = {passive: false};
      return true;
    }
  })
);


const loadScrollChange = () => {
  let rects = {};
  let inView = {};
  let stack = [];
  const targets = Array.from(
    document.querySelectorAll('[data-scroll-target]')
  );

  const handleResize = () => {
    for (const target of targets) {
      const key = target.getAttribute('data-scroll-target');
      rects[key] = target.getBoundingClientRect().top;
    }
  };
  window.addEventListener('resize', handleResize, passiveIfSupported);
  setTimeout(handleResize, 250);

  const handleEnter = key => {
    if (stack.indexOf(key) > -1) return;
    stack.push(key);
    const target = targets.find(
      t => t.getAttribute('data-scroll-target') === key
    );
    target.classList.add('active');
  };
  const handleExit = key => {
    if (stack.indexOf(key) === -1) return;
    stack = stack.filter(v => v !== key);
    const target = targets.find(
      t => t.getAttribute('data-scroll-target') === key
    );
    target.classList.remove('active');
  };

  const handleScroll = () => {
    const y = window.scrollY;
    for (const target of targets) {
      const key = target.getAttribute('data-scroll-target');
      const was = inView[key] || false;
      const is = rects[key] < y + window.innerHeight / 2;
      if (!was && is) {
        handleEnter(key);
      }
      if (!is && was) {
        handleExit(key);
      }
      inView[key] = is;
    }
  };
  window.addEventListener('scroll', handleScroll, passiveIfSupported);
  window.addEventListener('resize', handleScroll, passiveIfSupported);
};

ready(() => {
  loadScrollChange();
});
